import { CommonUtils } from "../(common-lib)/CommonUtils";
import { EmailTemplates } from "../(common-lib)/LoanData";

type SendEmailV2Options = {
  attachmentDocsTypes?: string[];
  bccEmail?: string[];
  bodyHtml?: string;
  ccEmail?: string[];
  emailTemplate?: string;
  forceSendEmail?: string;
  fromEmail: string;
  internalMail?: boolean;
  loanData?: any;
  subject?: string;
  templateData?: { [key: string]: string };
  toEmail: string;
};

export class MailClient {
  static async sendEmail( loanData: any, EmailTemplate: EmailTemplates, attachmentDocsTypes?: string[],
    internalMail: boolean = false, variables?: { [key: string]: string }): Promise<void> {

      const toEmail = loanData.brokerInfo?.email || loanData.contactInfo?.email;
      const jsonBody = JSON.stringify({
          version: '1.0',
          loanData,
          EmailTemplate,
          attachmentDocsTypes,
          internalMail: internalMail,
          variables
        })
      await this.sendEmailImpl(toEmail, '/api/mail/send', jsonBody);
  }

  static async sendTemplateEmailV2(
    fromEmail: string,
    toEmail: string,
    emailTemplate: string,
    templateData?: { [key: string]: string },
    ccEmail: string[] = [],
    bccEmail: string[] = [],
    internalMail: boolean = false,
    attachmentDocsTypes?: string[],
    loanData?: any,
  ): Promise<void> {
    return this.sendEmailV2({
      attachmentDocsTypes,
      bccEmail,
      ccEmail,
      emailTemplate,
      fromEmail,
      internalMail,
      loanData,
      templateData,
      toEmail,
    });
  }

  static async sendEmailV2(options: SendEmailV2Options): Promise<void> {
    const {
      attachmentDocsTypes,
      bccEmail,
      bodyHtml,
      ccEmail,
      emailTemplate,
      fromEmail,
      internalMail,
      loanData,
      subject,
      templateData,
      toEmail,
    } = options;

    const jsonBody = JSON.stringify({
      version: '2.0',
      attachmentDocsTypes,
      bccEmail: bccEmail || [],
      bodyHtml,
      ccEmail: ccEmail || [],
      emailTemplate,
      fromEmail,
      internalMail: internalMail || false,
      loanData,
      subject,
      templateData,
      toEmail,
    });

    await this.sendEmailImpl(toEmail, '/api/mail/send', jsonBody);
  }

  private static async sendEmailImpl( toEmail: string, apiRoute: string,jsonBody: string): Promise<void> {
    try {
      if (!toEmail) return;

      const urlParams = new URLSearchParams(window.location.search);
      const forceSendEmail = urlParams.get('force_send_email') || '';
      const parsedBody = JSON.parse(jsonBody);
      parsedBody.forceSendEmail = forceSendEmail;
      jsonBody = JSON.stringify(parsedBody);

      const startTime = performance.now();
      const res = await fetch(apiRoute, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: jsonBody
      });
      CommonUtils.logInfo(`Email API call took ${(performance.now() - startTime).toFixed(2)}ms`);

      if (res.ok) return;
      CommonUtils.logError(`Failed to send email: ${res.statusText}`);
    } catch (error) {
      CommonUtils.logError(`Exception while sending email:`, error);
    }
    alert('Failed to send email. Please try again.');
  }
}
